<template>
    <div>
        <h3>Atividades processadas</h3>
        <div>
            <div class="row task-made-form">
                <div class="form-group col-auto">
                    <date-picker
                        v-model ="filters.startDate"
                        format="DD/MM/YY"
                        v-mask="'##/##/##'"
                        v-on:change=changeFilters
                    >
                    </date-picker>
                </div>
                <div class="form-group col-auto">
                    <date-picker
                        v-model ="filters.endDate"
                        format="DD/MM/YY"
                        v-mask="'##/##/##'"
                        v-on:change=changeFilters
                    >
                    </date-picker>
                </div>
                <div class="form-group col-md-2 input-form">
                    <v-select
                        :reduce="user =>user.id"
                        placeholder="Funcionário"
                        label="name"
                        v-model="filters.user"
                        :options="users"
                        v-if="users"
                        v-on:input=changeFilters
                    />
                </div>
                <div class="form-group col-md-1 input-form">
                    <v-select
                        :reduce="task =>task.id"
                        placeholder="Atividade"
                        label="name"
                        v-model="filters.task"
                        :options="tasks"
                        v-if="tasks"
                        v-on:input=changeFilters
                    />
                </div>
                <div class="form-group col-md-1 input-form">
                    <v-select
                        :reduce="taskType => taskType.id"
                        placeholder="Classificação"
                        label="name"
                        v-model="filters.taskType"
                        :options="taskTypes"
                        v-if="taskTypes"
                        v-on:input=changeFilters
                    />
                </div>
                <div class="form-group col-md-2 input-form">
                    <v-select
                        :reduce="customer => customer.id"
                        placeholder="Cliente"
                        label="name"
                        v-model="filters.customer"
                        :options="customers"
                        v-if="customers"
                        v-on:input=changeFilters
                    />
                </div>
                <div class="form-group col-md-2 input-form">
                    <input
                        class="form-control"
                        type="text"
                        v-model="filters.note"
                        placeholder="Observação"
                        name="note"
                        v-on:blur=changeFilters
                        v-on:keyup="search"
                    >
                </div>
                <div class="form-group col-md-1">
                    <button class="form-control btn btn-danger" v-on:click="clearFilters">Limpar</button>
                </div>
                <div class="form-group col-md-1">
                    <button class="form-control btn btn-primary" v-on:click="csv">Baixar CSV</button>
                </div>
                <div>

                </div>
            </div>
            <br />
            <div v-if="loading" >
                <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div>
            <div class="row customer-costs">
                <div class="header-fixed">
                    <div class="header fake-table">
                        <div class="name">Usuário</div>
                        <div class="user-data">Data</div>
                        <div class="user-data">Início</div>
                        <div class="user-data">Fim</div>
                        <div class="user-data">Total</div>
                        <div class="user-data">H. custo</div>
                        <div class="user-data">R$ atividade</div>
                        <div class="user-data">H. Indireta</div>
                        <div class="user-data">R$ h. indiretas</div>
                        <div class="user-data">H. Total</div>
                        <div class="user-data">R$ total</div>
                        <div class="user-data">Atividade</div>
                        <div class="user-data">Tipo trabalho</div>
                        <div class="user-customer">Cliente</div>
                        <div class="user-note">Observações</div>
                    </div>
                </div>
                <div v-for="taskMade in tasksMade" :key="taskMade.id">
                    <div class="fake-table">
                        <div class="name">{{ taskMade.user_name }}</div>
                        <div class="user-data">{{ formatDateBr(taskMade.made_at) }}</div>
                        <div class="user-data">{{ taskMade.started_at }}</div>
                        <div class="user-data">{{ taskMade.finished_at }}</div>
                        <div class="user-data">{{ secondsToDate(taskMade.time_spent) }}</div>
                        <div class="user-data">{{ numberFormat(taskMade.cost_hours_worked) }}</div>
                        <div class="user-data">{{ numberFormat(taskMade.cost_task) }}</div>
                        <div class="user-data">{{ secondsToDate(taskMade.time_spent_prop) }}</div>
                        <div class="user-data">{{ numberFormat(taskMade.cost_task_prop) }}</div>
                        <div class="user-data">{{ secondsToDate(taskMade.time_spent_total) }}</div>
                        <div class="user-data">{{ numberFormat(taskMade.cost_task_total) }}</div>
                        <div class="user-data">{{ taskMade.task_name }}</div>
                        <div class="user-data">{{ taskMade.task_type_name }}</div>
                        <div class="user-customer">{{ taskMade.customer_name }}</div>
                        <div class="user-note">{{ taskMade.note }}</div>
                    </div>
                </div>
            </div>

            <div
                v-observe-visibility="visibilityChanged"
                class="text-center"
            >
                <i v-if="loading && hasNextPage" class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import { mapGetters } from 'vuex'

export default {
    name: 'TasksMadeClosure',
    components: {
        DatePicker
    },
    data () {
        return {
            loading: false,
            tasks: false,
            taskTypes: false,
            customers: false,
            users: false,
            task_id: 0,
            task_type_id: 0,
            customer_id: 0,
            tasksMade: [],
            filters: {
                startDate: new Date (),
                endDate: new Date (),
                task: '',
                taskType: '',
                customer: '',
                note: ''
            },
            stringFilters: null,
            loadStringFilters: false,
            searchTimeout: null,
            total_spent: 0,
            totalCostTask: 0,
            count: true,
            pagination: {},
            page: 1
        }
    },
    computed: {
        hasNextPage () {
            return this.pagination.current_page < this.pagination.total_pages
        },
        ...mapGetters({
            token: 'auth/token',
        }),
    },

    mounted() {
        this.clearDate()
        this.loadFormOptions()
        this.loadFilters()
        this.searchTasksMade()
    },

    methods: {
        visibilityChanged (isVisible) {
            this.loading = true
            if (this.hasNextPage && isVisible) {
                this.page++
                if (this.loadStringFilters) {
                    this.count = false
                    this.builderFilters()
                } else {
                    this.searchTasksMade()
                }
            }
            this.loading = false
        },
        numberFormat (number) {
            return new Intl.NumberFormat('pt-BR',{style: 'currency', currency: 'BRL'}).format(number)
        },
        clearDate () {
            this.tasksMade = []
            this.page = 1
            this.count = true
        },
        search () {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.builderFilters()
            }, 1000)
        },
        searchTasksMade () {
            if (!this.loadStringFilters) {
                let firstDay = new Date(this.filters.startDate.getFullYear(), this.filters.startDate.getMonth(), 1);
                this.filters.startDate = firstDay
                this.stringFilters = 'page=' + this.page
                    + '&startDate=' + this.formatDate(firstDay)
                    + '&endDate=' + this.formatDate(this.filters.endDate)
            }

            this.loading = true
            axios
                .get('/api/tasks_made_verification?' + this.stringFilters)
                .then((response) => {
                    this.tasksMade.push(...response.data.data)
                    this.pagination = response.data.meta.pagination
                    for (let index in this.tasksMade) {
                        if (this.tasksMade[index].made_at.length === 10) {
                            this.tasksMade[index].made_at = new Date(this.tasksMade[index].made_at + ' 12:00:00')
                        }
                    }
                    this.loading = false
                })
        },
        loadFilters () {
            this.filters = {
                startDate: new Date (),
                endDate: new Date (),
                user: '',
                task: '',
                taskType: '',
                customer: '',
                note: ''
            }
        },
        formatDate (date) {
            return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
        },
        formatDateBr (date) {
            return (("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear());
        },
        secondsToDate (seconds) {
            if (isNaN(seconds)) {
                return '00:00:00'
            }
            let hours = Math.floor(seconds / 3600)
            seconds %= 3600
            let minutes = Math.floor(seconds / 60)
            seconds = seconds % 60

            return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
        },
        loadFormOptions () {
            axios.get('/api/users').then((response) => {
                this.users = response.data.data
            })
            axios
                .get('/api/tasks')
                .then((response) => {
                    this.tasks = response.data
                })
            axios
                .get('/api/task_types')
                .then((response) => {
                    this.taskTypes = response.data.data
                })
            axios
                .get('/api/customers')
                .then((response) => {
                    this.customers = response.data.data
                })
        },
        changeFilters () {
            this.count = true
            this.builderFilters()
        },
        builderFilters () {
            this.loading = false
            if (this.count) {
                this.clearDate()
            }
            let filters = {
                page: this.page,
                startDate: this.formatDate(this.filters.startDate),
                endDate: this.formatDate(this.filters.endDate)
            }

            if (this.filters.user) {
                filters.user_id = this.filters.user
            }

            if (this.filters.task) {
                filters.task = this.filters.task
            }

            if (this.filters.taskType) {
                filters.taskType = this.filters.taskType
            }

            if (this.filters.customer) {
                filters.customer = this.filters.customer
            }

            if (this.filters.note) {
                filters.note = this.filters.note
            }
            this.builderFiltersString(filters)
        },
        builderFiltersString (filters) {
            let filterString = ''
            for (let filter in filters) {
                if (filters[filter] != null) {
                    filterString += filter + '=' + filters[filter] + '&'
                }
            }
            this.stringFilters = filterString.substring(0, filterString.length - 1)
            this.loadStringFilters = true
            this.searchTasksMade()
        },
        clearFilters () {
            this.clearDate()
            this.stringFilters = ''
            this.loadFilters()
            this.loadStringFilters = false
            this.searchTasksMade()
        },
        csv () {
            this.clearDate()
            this.builderFilters()
            window.open(process.env.VUE_APP_URL + '/api/tasks_made_verification/csv?'  + this.stringFilters + '&api_token='+ this.token)
        }
    }
}
</script>

<style scoped lang="sass">
    .btns
        margin-left: 20px

    .customer-costs
        margin-top: 20px
        width: 1840px
        font-size: 12px

    .fake-table
        border: 1px solid
        display: inline-block

        .name
            display: inline-block
            width: 200px
            max-width: 300px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            padding: 8px
            margin-bottom: -8px

        .user-data
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 8px
            margin-bottom: -8px

        .user-customer
            overflow: hidden
            display: inline-block
            width: 100px
            border-left: 1px solid
            padding: 8px
            margin-bottom: -8px

        .user-note
            overflow: hidden
            display: inline-block
            width: 250px
            border-left: 1px solid
            padding: 8px
            margin-bottom: -8px
            scroll-behavior: auto

    .header-fixed
        background: white
        position: -webkit-sticky
        position: sticky
        top: 55px
        padding-top: 5px

    .header-total
        background: #bdbdbd7a

</style>
